var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icon-css-sy",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 160,
    y: 160,
    fill: "#fff",
    fillRule: "evenodd",
    rx: 0,
    ry: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 160,
    y: 320,
    fillRule: "evenodd",
    rx: 0,
    ry: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    d: "M0 0h640v160H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    fillRule: "evenodd",
    d: "M201.9 281l-28.8-20.9-28.7 21.1 10.7-34.2-28.7-21.2 35.4-.3 11-34.1 11.3 34h35.4L191 246.9l10.9 34.2zm307.6 0l-28.8-20.9-28.7 21.1 10.7-34.2-28.6-21.2 35.4-.3 11-34.1 11.2 34h35.4l-28.5 21.4 11 34.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSy);
export default __webpack_public_path__ + "static/media/sy.6529aa17e46f775a39317b1ed78a526d.svg";
export { ForwardRef as ReactComponent };